import React from 'react';

import { Row, Col, Space, Typography } from 'antd';
const { Title, Text} = Typography;

const ColorPreview = (props) => {
  return (
    <>
      {/* <Col>

      </Col> */}
      {/* <center> */}
        <Col >
        <Space>
          Preview: 
            <div id="color" style={{ width: "25px", height: "25px" }} ></div>
            <div id="status"></div>
          </Space>
        </Col>
      {/* </center> */}
    </>
  );
};

export default ColorPreview;